__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "doHealthFrontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "13.3.2", () => (__webpack_require__.e(4527).then(() => (() => (__webpack_require__(4527))))));
			register("@angular/common", "13.3.2", () => (__webpack_require__.e(1160).then(() => (() => (__webpack_require__(674))))));
			register("@angular/core", "13.3.2", () => (__webpack_require__.e(5084).then(() => (() => (__webpack_require__(5084))))));
			register("@angular/forms", "13.3.2", () => (__webpack_require__.e(7233).then(() => (() => (__webpack_require__(7233))))));
			register("@angular/material/button", "13.3.2", () => (__webpack_require__.e(7350).then(() => (() => (__webpack_require__(7350))))));
			register("@angular/material/card", "13.3.2", () => (__webpack_require__.e(8738).then(() => (() => (__webpack_require__(8738))))));
			register("@angular/material/checkbox", "13.3.2", () => (__webpack_require__.e(9574).then(() => (() => (__webpack_require__(9295))))));
			register("@angular/material/core", "13.3.2", () => (__webpack_require__.e(6911).then(() => (() => (__webpack_require__(6911))))));
			register("@angular/material/dialog", "13.3.2", () => (__webpack_require__.e(3978).then(() => (() => (__webpack_require__(3986))))));
			register("@angular/material/divider", "13.3.2", () => (__webpack_require__.e(7808).then(() => (() => (__webpack_require__(7808))))));
			register("@angular/material/expansion", "13.3.2", () => (__webpack_require__.e(2209).then(() => (() => (__webpack_require__(1939))))));
			register("@angular/material/form-field", "13.3.2", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("@angular/material/grid-list", "13.3.2", () => (__webpack_require__.e(705).then(() => (() => (__webpack_require__(705))))));
			register("@angular/material/icon", "13.3.2", () => (__webpack_require__.e(7758).then(() => (() => (__webpack_require__(7758))))));
			register("@angular/material/input", "13.3.2", () => (__webpack_require__.e(9325).then(() => (() => (__webpack_require__(9325))))));
			register("@angular/material/list", "13.3.2", () => (__webpack_require__.e(5226).then(() => (() => (__webpack_require__(5226))))));
			register("@angular/material/menu", "13.3.2", () => (__webpack_require__.e(4946).then(() => (() => (__webpack_require__(4946))))));
			register("@angular/material/progress-bar", "13.3.2", () => (__webpack_require__.e(1688).then(() => (() => (__webpack_require__(1688))))));
			register("@angular/material/progress-spinner", "13.3.2", () => (__webpack_require__.e(3326).then(() => (() => (__webpack_require__(3326))))));
			register("@angular/material/select", "13.3.2", () => (__webpack_require__.e(196).then(() => (() => (__webpack_require__(196))))));
			register("@angular/material/sidenav", "13.3.2", () => (__webpack_require__.e(7276).then(() => (() => (__webpack_require__(7276))))));
			register("@angular/material/snack-bar", "13.3.2", () => (__webpack_require__.e(3544).then(() => (() => (__webpack_require__(3544))))));
			register("@angular/material/stepper", "13.3.2", () => (__webpack_require__.e(1652).then(() => (() => (__webpack_require__(1652))))));
			register("@angular/material/table", "13.3.2", () => (__webpack_require__.e(8865).then(() => (() => (__webpack_require__(8865))))));
			register("@angular/material/tabs", "13.3.2", () => (__webpack_require__.e(4750).then(() => (() => (__webpack_require__(4750))))));
			register("@angular/material/toolbar", "13.3.2", () => (__webpack_require__.e(5853).then(() => (() => (__webpack_require__(5853))))));
			register("@angular/material/tree", "13.3.2", () => (__webpack_require__.e(6502).then(() => (() => (__webpack_require__(6502))))));
			register("@angular/router", "13.3.2", () => (__webpack_require__.e(3677).then(() => (() => (__webpack_require__(6547))))));
			register("angular-fusioncharts", "3.2.3", () => (__webpack_require__.e(2399).then(() => (() => (__webpack_require__(712))))));
			register("fusioncharts", "3.20.0", () => (__webpack_require__.e(7122).then(() => (() => (__webpack_require__(7122))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};